import { render, staticRenderFns } from "./AgentManagementEdit.vue?vue&type=template&id=0f0aba5e"
import script from "./AgentManagementEdit.vue?vue&type=script&lang=js"
export * from "./AgentManagementEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports